import PropTypes from 'prop-types';
import MatchMedia from '../ui/MatchMedia/MatchMedia';
import CartDesktop from './CartDesktop/CartDesktop';
import CartMobile from './CartMobile/CartMobile';

const CartSection = ({ setBusy, cart, hasCrossSelling, setCrossSelling, showWarrantyModal, isWarrantyAdded }) => {
  const desktop = () => (
    <CartDesktop
      cart={cart}
      setBusy={setBusy}
      hasCrossSelling={hasCrossSelling}
      setCrossSelling={setCrossSelling}
      showWarrantyModal={showWarrantyModal}
      isWarrantyAdded={isWarrantyAdded}
    />
  );
  const noDesktop = () => <CartMobile cart={cart} setBusy={setBusy} />;

  return (
    <MatchMedia
      content={{
        desktop,
        mobile: noDesktop,
        tablet: noDesktop,
      }}
    />
  );
};

CartSection.defaultProps = {
  showWarrantyModal: () => {},
  isWarrantyAdded: true,
};

CartSection.propTypes = {
  setBusy: PropTypes.func.isRequired,
  cart: PropTypes.object.isRequired,
  hasCrossSelling: PropTypes.bool.isRequired,
  setCrossSelling: PropTypes.func.isRequired,
  showWarrantyModal: PropTypes.func,
  isWarrantyAdded: PropTypes.bool,
};

export { CartSection };
